import './App.css'
import './index.css'

export function GIS() {
    return (
        <>
         <div className="gis">
            <h2 className="heading">GIS Work</h2>
            <p>I also have a solid foundation in GIS. See my latest project below.</p>
            <p><a href="https://irosenb-portfolio.s3.us-west-2.amazonaws.com/Jersey+City%E2%80%99s+Housing+Crisis.pdf" target="_blank" rel="noopener noreferrer">Jersey City's Housing Crisis</a></p>
        </div>
        </>
    )
}